import React from 'react';
import Nbsp from './Nbsp';

/**
 * @typedef {object} ReportInfoItemProps
 * @property {string} label
 * @property {string|number} [value]
 */

/**
 * @param {ReportInfoItemProps} props
 */
const ReportInfoItem = props => {
  const { label, value } = props;

  return (
    <p className='report-info-item'>
      <strong>
        {label}:<Nbsp />
      </strong>
      {value ?? 'N/A'}
    </p>
  );
};

export default ReportInfoItem;
